import { render } from "./AddCaissePage.vue?vue&type=template&id=49d68aee&ts=true"
import script from "./AddCaissePage.vue?vue&type=script&lang=ts"
export * from "./AddCaissePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__